
import axios from "axios";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import { Box } from '@mui/material';
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next"
import { useParams, useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import { handleErrors } from "common.js";
import configurationContext from "contextConfig";
import { CircularProgress, Backdrop } from "@mui/material";

function EmailTemplates() {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [templatesdata, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [responseResultCount, setResponseResultCount] = useState(0);
  const MyContext = useContext(configurationContext);
  var pageSelected = 1;
  const { pageNo } = useParams();

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const columns = [
    { Header: t("id"), accessor: "id", width: "5%", align: "left" },
    { Header: t("name"), accessor: "name", width: "20%", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const data = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/configuration/listTemplates?pageSelected=" + pageSelected,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    })
      .then(function (response) {
        setIsLoading(false);
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setResponseResultCount(response.data.data.totalCount)
            setData(response.data);
          }
          else {
            if (message)
              toast.error(t(message))    
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const rows = [];

  for (const key in templatesdata.data) {
    if (templatesdata.data.hasOwnProperty(key)) {
      let dataObj = templatesdata.data[key];
      if (key == 'rows') {
        for (const key1 in dataObj) {
          let dataRow = dataObj[key1];
          let tempRow = {
            "id": dataRow.id,
            'name': dataRow.name,
            "action": <MDTypography component="a" href={"#"} onClick={(event) => { event.preventDefault(); navigate("/admin/viewTemplate/" + dataRow.id) }} variant="caption" color="text" fontWeight="medium">
              <Tooltip title={t('edit')}><Box className="ActionEdit"><EditIcon /></Box></Tooltip>
            </MDTypography>
          };
          rows.push(tempRow);
        }
      }
    }
  }

  return (
<DashboardLayout>
  <DashboardNavbar pageTitle={t('manage email template')} />
  <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
    <CircularProgress color="inherit" />
  </Backdrop>
  <MDBox pt={6} pb={3}>
    <Grid container spacing={6}>
      <Grid item xs={12}>
        <Card>
          <MDBox pt={3}>
            {templatesdata ? (
              <DataTable
                table={{ columns, rows }}
                isSorted={false}
                showTotalEntries={true}
                responseResultCount={responseResultCount}
                paginationSize={MyContext.paginationSize}
                paginationLink={"/admin/emailTemplates/page-"}
                pageSelected={pageSelected}
              />
            ) : null}
          </MDBox>
        </Card>
      </Grid>
    </Grid>
  </MDBox>
</DashboardLayout>

  );
}

export default EmailTemplates;
